// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1f2f66fc","453":"941bc90e","455":"21a7c6e8","977":"eae6d3ae"}[chunkId] + ".chunk.js";
};